import { gql } from '@apollo/client';

export const UPDATE_COFFEE_CHAT_SETTINGS = gql`
  mutation updateCoffeeChatSettings($settings: CoffeeChatSettingsInput!) {
    updateCoffeeChatSettings(settings: $settings) {
      id
      coffeeChatFrequency
      coffeeChatAvailability
      coffeeChatAutoIcebreaker
      coffeeChatPreferences
    }
  }
`;